import { Box, styled } from "@mui/material";

export const CustomFieldsFormWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 1rem;
`

export const CustomFieldsWrapper = styled(Box)`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
`;

export const FieldWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

export const ArrayItem = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex-direction: row;
  margin-right: 0.5rem;
`;